import moment from 'moment';
import {CONSTANTS} from '../constants';

export const checkCloudOffline = (last_activity_date, serverState) => {
  return false;
  const isServerSleeping = serverState && serverState === 'stopped';
  const duration = moment.duration(moment().utc().diff(moment.utc(last_activity_date, 'YYYY-MM-DD HH:mm:ss')));
  return duration.asMinutes() > CONSTANTS.limits.could_offline_minutes && !isServerSleeping;
};
